import React from 'react';
import AppVideoPlayer from '../../AppVideoPlayer/AppVideoPlayer';
import {ExtractedVideoParams} from '../../AppVideoPlayer/utils/extractVideoParamsFromUmbraco';

interface LegacyVideoPlayerProps {
  extractedParams?: ExtractedVideoParams | null;
}

const LegacyVideoPlayer: React.FC<LegacyVideoPlayerProps> = ({
  extractedParams,
}) => <AppVideoPlayer extractedParams={extractedParams} />;

export default LegacyVideoPlayer;
